import { formatCurrency } from '../../../../common/SharedFunctions';
import { EditBudgetButton } from './EditBudgetButton';
import { ProblemPropertyIndicator } from './ProblemPropertyIndicator';

export const InpectingBudgetDrawPanel = ({ property, styles, validateSubmission, onProblemPropertyChange }) => {
    const latestDraw = property?.drawHistoryLines?.length && property?.drawHistoryLines[property?.drawHistoryLines?.length - 1];

    return (
        <div style={styles.displayFlex}>
            <span style={{ marginRight: 20, color: 'red' }}>INSPECTING {formatCurrency(latestDraw.amountInspected, 0)}</span>
            <EditBudgetButton
                property={property}
                styles={styles}
                validateSubmission={validateSubmission}
            />
            <ProblemPropertyIndicator
                problemProperty={property.isProblemProperty}
                onChange={onProblemPropertyChange}
            />
        </div>
    );
};
